import styled from "styled-components";

export const ButtonContainer = styled.button`
  text-transform: capitalize;
  font-size: 0.95rem;
  font-weight: 600;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  border: none;
  color: white;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  margin: 0.3rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(231, 76, 60, 0.3);
  
  &:hover {
    background: linear-gradient(135deg, #c0392b 0%, #e74c3c 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(231, 76, 60, 0.3);
  }
  
  &:focus {
    outline: 2px solid rgba(231, 76, 60, 0.5);
    outline-offset: 2px;
  }
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.45rem 0.9rem;
    width: 100%;
    margin: 0.3rem 0;
  }
`;
